import React from 'react';
import { PersonaCardBody } from './PersonaCardBody';

interface PersonaHoverCardProps {
  persona: any;
  isVisible: boolean;
}

// Hover shell — owns absolute positioning + visibility transition.
// Delegates all content to PersonaCardBody. For v0.4 rich DAG nodes,
// consume PersonaCardBody directly (the card IS the deep-dive; no
// separate hover layer needed inside a rich node).
export const PersonaHoverCard: React.FC<PersonaHoverCardProps> = ({
  persona,
  isVisible,
}) => {
  if (!isVisible || !persona) return null;
  return (
    <div
      className={`absolute right-0 top-12 w-80 shadow-xl z-50 transition-all duration-200 ${
        isVisible
          ? 'opacity-100 translate-y-0'
          : 'opacity-0 -translate-y-2 pointer-events-none'
      }`}
    >
      <PersonaCardBody persona={persona} />
    </div>
  );
};
